let React              = require("react");

let Application        = require("../../Application.js");
let Overlay            = require("../../controls/modals/Loading.jsx");
let ErrorMessage       = require("../../controls/modals/ErrorMessage.jsx");
let ApplicationContext = require("../../../shared/config/ApplicationContext.js");
let LoginUtil          = require("../../util/LoginUtil.js")

class ErrorPage extends React.Component {

    constructor() {
        super()
        this.state = {
            show: false, 
            title: "", 
            failMessage: "", 
            helpMessage: "", 
            serverMessage: "",
        };

        this.setError = this.setError.bind(this); 
        this.handleError = this.handleError.bind(this); 
        this.onErrorClose = this.onErrorClose.bind(this); 
    }

    setError(show, title, failMessage, helpMessage, serverMessage, onClose, CustomOptions){
        if (onClose) this.errorCloseAction = onClose;
        this.setState({ show, title, failMessage, helpMessage, serverMessage, CustomOptions});
    }

    handleError(err, intent, customMessage, onClose){
        // console.trace(err)
        let logServerErrors=true; // many configure this and turn off on prod?

        let title = "";
        let failMessage = null;
        let helpMessage = null;
        let serverMessage = null;
        let CustomOptions = () => null;
        
        if(intent){
            failMessage = `Failed to ${intent}. `;
        }
        
        if(logServerErrors && err && err.statusText){
            serverMessage = err.statusText;
        }

        if(logServerErrors && err && err.message){
            serverMessage += ` "${err.message}"`;
        }

        if(customMessage){
            helpMessage = customMessage;
        }

        if(err && err.status !== undefined ){
            if(err.status != 0) title += `Error ${err.status}: `;

            if(err.status == 0) title += "The server could not be reached.";
            else if(err.status == 401){ 
                title += "User must be logged in to see this content.";
                CustomOptions = () => <button className="button" onClick={this.login}>Sign In</button>
            }           
            else if(err.status == 403){
                title += `The user is not authorized to see this content.`;
                serverMessage = `Currently logged in as ${ApplicationContext.getUserData().name}`;
                CustomOptions = () => <button className="button" onClick={this.logout}>Sign Out</button>
            }
            else if(err.status == 404) title += "The requested content does not exist.";
            else if(err.status == 408) title += "The connection has timed out.";
            else if(err.status == 409) title += "There is a conflict with this request.";
            else if(err.status == 500) title += "The server has encountered an error.";
            else title += "An error has occurred."
            
        } else {
            title = "An error has occurred."
        }
       
        this.setError(true, title, failMessage, helpMessage, serverMessage, onClose, CustomOptions);
    }

    logout() {
        googleGA("send", "event", "errorPage", "signout");
        Application.dataStore.logoutUser();
    }

    login() {
        googleGA("send", "event", "errorPage", "signin");
        Application.dataStore.doAuth();
    }

    onErrorClose(){
        this.setError(false);
        if(this.errorCloseAction) this.errorCloseAction();
        this.errorCloseAction = null;
    }

    render() {
        const { renderPage } = this.props;
        const { 
            show, 
            title, 
            failMessage, 
            helpMessage, 
            serverMessage,
            CustomOptions
        } = this.state;

        return(
            <React.Fragment>
                {/* Pass the handlers down to children */}
                { renderPage({
                    setError:this.setError,
                    handleError:this.handleError
                })}
                
                <Overlay show={show}>
                    <ErrorMessage 
                        title={title} 
                        failMessage={failMessage} 
                        helpMessage={helpMessage} 
                        serverMessage={serverMessage} 
                        CustomOptions={CustomOptions} 
                        onClose={this.onErrorClose}
                    />
                </Overlay>
            </React.Fragment>
        );
    }
}

module.exports = ErrorPage;
